<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconShuffle_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="m13.121 4.312 3.59 1.237L3.746 18.842a1.33 1.33 0 0 0 0 1.85 1.251 1.251 0 0 0 1.803 0L18.513 7.396l1.207 3.681a.657.657 0 0 0 .728.452.667.667 0 0 0 .552-.665V3.673A.664.664 0 0 0 20.343 3H13.33a.664.664 0 0 0-.649.565.675.675 0 0 0 .44.747Zm6.6 9.608-1.207 3.681-3.644-3.737a1.251 1.251 0 0 0-1.803 0 1.33 1.33 0 0 0 0 1.849l3.644 3.737-3.589 1.237a.677.677 0 0 0-.44.747.66.66 0 0 0 .648.566h7.013c.363 0 .657-.3.657-.673v-7.192a.67.67 0 0 0-.551-.666.655.655 0 0 0-.728.451ZM3.369 3.93a1.331 1.331 0 0 0 .01 1.849l5.052 5.126c.5.508 1.308.504 1.803-.01a1.332 1.332 0 0 0-.01-1.849L5.173 3.92a1.253 1.253 0 0 0-1.803.01Z"
        clip-rule="evenodd"
    />
</svg>
